import gql from 'graphql-tag';

export default gql`
    fragment TaskFragment on Task {
        ID
        Created
        LastEdited
        Title
        Description
        Category
        RequiredAction
        TabURLSegment
        Due
        InProgress
        Completed
        Archived
        Comment
        LinkURL
        RecurFreq
        RecurType
        RecurEnds
        Comment
        Master {
            ID
        }
        Cremation {
            ID
            LegacyKey
            NameOfDeceased
        }
        Plaque {
            ID
            LegacyKey
            NameOfDeceased
        }
        EnquiryCM {
            ID
            LegacyKey
            NameOfDeceased
        }
        EnquiryFM {
            ID
            LegacyKey
            NameOfDeceased
        }
        Funeral {
            ID
            LegacyKey
            NameOfDeceased
        }
        Recurrences {
            ID
        }

        Audits {
            edges {
                node {
                    ID
                    Created
                    Type
                    Comment
                    AddedBy {
                        ID
                        Email
                        Surname
                        FirstName
                    }
                }
            }
        }

        AssignedMembers {
            ID
            Email
            Surname
            FirstName
            _join {
                TaskMembers {
                    ID
                    Starred
                }
            }
        }
        AssignedTeams {
            ID
            Title
        }
        AssignedLabels {
            ID
            Title
            Member {
                ID
            }
        }
        ChecklistItems {
            ID
            Title
            Completed
        }
        Attachments {
            ... on File {
                ID
                Name
                Size
                AbsoluteLink
            }
            ... on Image {
                ID
                Name
                Size
                AbsoluteLink
            }
        }
    }
`;
